<template>
    <v-container class="fill-height" fluid>
        <v-flex :class="{'py-2': $vuetify.breakpoint.smAndDown}">
        <v-layout row justify-center>
        <!-- Skeleton Loading -->
        <v-flex xs10 md8 xl7 v-if="loading">
            <v-layout row justify-center>
                <v-flex xs12 lg6 class="pa-3">
                    <v-skeleton-loader type="table" class="my-4"></v-skeleton-loader>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs10 md8 xl7 v-if="!loading">
            <v-layout row>
                <v-spacer></v-spacer>
                <v-btn class="mb-3 text-none" depressed color="grey lighten-2" to="/">Beranda<v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-flex xs12>
                <v-layout row justify-center>
                    <v-flex xs12 lg6 class="pa-3">
                        <v-card :loading="loading">
                            <v-toolbar
                                color="primary"
                                dark
                                flat
                                class="px-5"
                            >
                                <v-toolbar-title>Lembar Skor</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-card outlined tile>
                                    <v-card-title class="font-weight-bold">TOTAL SKOR</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text class="py-8 display-1 font-weight-bold text-center">
                                        {{skor}}                                   
                                    </v-card-text>
                                </v-card>
                                <v-card outlined tile class="my-4">
                                    <v-card-title class="font-weight-bold">INDIKATOR SKOR</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text class="py-8 title font-weight-bold text-center">
                                        {{indikator}}
                                    </v-card-text>
                                </v-card>
                                <v-card outlined tile class="d-flex flex-column align-center">
                                    <v-img :src="emoticon" v-if="emoticon" width="100px" class="mt-8">
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                    <v-card-text class="py-8 title font-weight-bold text-center" v-sanitize="saran">
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row class="lighter-grey--text caption font-weight-thin mt-5 text-center" justify-center>Copyright {{ new Date().getFullYear() }} © Grafindo Media Pratama. All Right Reserved.</v-layout>
        </v-flex>
        <!-- Loading dialog replaced by skeleton loader -->
            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="headline">Success</v-card-title>
                    <v-card-text>{{ message }}</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog=false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogOffline" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Offline</v-card-title>
                    <v-card-text>Tidak ada internet, silahkan coba kembali</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="get">Coba lagi</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        </v-flex>
    </v-container>
</template>

<script>
import * as api from '@/api'
import store from '../store/store'
  export default {
    data(){
        return {
            loading: false,
            cobas: [
                {
                    id: 1,
                    nama: 'Coba',
                },
                {
                    id: 2,
                    nama: 'Nyobian'
                },
                {
                    id:3,
                    nama: 'Mencoba'
                }
            ],
            // mapel: JSON.parse(localStorage.getItem('mapel')),
            mapelNew: {},
            jawaban: {},
            kategori: {},
            indikator: '',
            saran: '',
            skor: 0,
            emoticon: null,
            dialog: false,
            message: '',
            dialogOffline: false
        }
    },
    methods:{
        ulangi(){
            var id_mapel, id_paket
            id_mapel = this.mapel.id
            id_paket = this.mapel.id_paket
            store.commit('removeMapel')
            this.$router.push('/paket/'+id_mapel+'/soal/'+id_paket)
        },
        toggleActive(coba){
            this.$set(coba, 'active', !coba.active)
        },
        async get(){
            this.loading = true
            this.dialogOffline = false
            if(navigator.onLine){
                var options = { year: 'numeric', month: 'long', day: 'numeric' }
                var date = new Date()
                this.mapel.soal.forEach(element => {
                    this.$set(element, 'soal', null)
                    this.$set(element, 'audio', null)
                    this.$set(element, 'pilihan_jawaban', null)
                });
                this.mapel.tanggal = date.toLocaleDateString("id-ID", options)
                await api.post('/penilaian', this.mapel, async (res) => {
                    if (res.status) {
                        this.skor = res.data.skor
                        var kat = res.data.kategori
                        this.indikator = kat.kriteria
                        this.saran = kat.saran
                        this.emoticon = kat.emoticon
                        this.loading = false
                        if(res.data.status){
                            this.dialog = true
                            this.message = res.data.message
                            // store.commit('removeMapel')
                        }
                    }
                })
            }else{
                this.loading = false
                this.dialogOffline = true
            }
        }
    },
    watch: {
        
    },
    mounted(){
        // this.mapel = JSON.parse(localStorage.getItem('mapel'))
        this.get()
    },
    computed: {
        mapel(){
            return this.$store.state.mapel
        }
    }
  }
</script>

<style scoped>
    .answer-field{
        min-width: 9.06px;
    }
    .left-side{
        min-width: 173px;
    }
</style>